export default __webpack_public_path__ + "static/media/repsol-logo.b3b7dd85.png";